define('constants/howWillYouUseTrestaEnumerations',[], function() {
    return {
        business: "business",
        personal: "personal"
    };
});

